import React, { memo } from 'react';
import styles from './GroupedReportsCard.module.scss';
import { SFCard, SFDivider, SFScrollable, SFText } from 'sfui';
import { GroupedReportsCardTable } from './GroupedReportsCardTable/GroupedReportsCardTable';
import { ReportValue } from '../../Models';

export interface GroupedReportsCardProps {
  showOfficer?: boolean;
  title: string;
  reports: ReportValue[];
}

export const GroupedReportsCard = memo(
  function ({
    showOfficer,
    title,
    reports
  }: GroupedReportsCardProps): React.ReactElement<GroupedReportsCardProps> {
    return (
      <SFCard
        className={styles.groupedReportsCard}
        containerClassName={styles.container}
        sfElevation={2}
      >
        <SFText className={styles.title} type="component-title">
          {title}
        </SFText>
        <SFDivider size={2} />
        <SFScrollable containerClassName={styles.scrollable}>
          <GroupedReportsCardTable
            showOfficer={showOfficer}
            reports={reports}
          />
        </SFScrollable>
      </SFCard>
    );
  },
  (prev: GroupedReportsCardProps, next: GroupedReportsCardProps) =>
    prev.title === next.title && prev.reports.length === next.reports.length
);
